import { LOADED } from "../../../middleware/actionNames"

import { CLONE, REPUBLISH, SELECT, UPDATE } from "../../../utility"
import { LOGOUT } from "../../core/authentication/actionNames"
import { JOURNEY } from "../../entities/journeys/actionNames"
import { COMPANY } from "../../entities/companies/actionNames"
import { SCROLL_POSITION, RULES_PANEL } from "./actionNames"

//  Required variables
export const initialState = {
    /* Holds the scrollPosition in the journeyEdit page */
    scrollPosition: 0,
    /* Holds the hash of the currently cloned journey */
    clonedJourneyHash: null,
    /* Holds the hash of the currently previewed journey */
    previewedJourneyHash: null,
    /* Holds current state of rules panel */
    showRulesPanel: false,
}

// Reducer
export const reducers = {
    [SCROLL_POSITION + UPDATE](state, scrollPosition) {
        return {
            ...state,
            scrollPosition,
        }
    },

    [RULES_PANEL](state, showRulesPanel) {
        return {
            ...state,
            showRulesPanel,
        }
    },

    [JOURNEY + CLONE](state, { journeyHash: clonedJourneyHash }) {
        return {
            ...state,
            clonedJourneyHash,
        }
    },

    [JOURNEY + REPUBLISH + LOADED](state) {
        return {
            ...state,
            clonedJourneyHash: null,
        }
    },

    // Reset reducers
    [LOGOUT + LOADED]() {
        return initialState
    },

    [JOURNEY + SELECT]({ clonedJourneyHash }) {
        return {
            ...initialState,
            clonedJourneyHash,
        }
    },

    [COMPANY + SELECT]({ clonedJourneyHash }) {
        return {
            ...initialState,
            clonedJourneyHash,
        }
    },
}
